import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduce, lowerCase } from 'lodash';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import GodTable, { CUSTOM_FIELD_TYPES } from '../../../../components/god-table';
import { getTablePreference } from '../../../App/AppReducer';
import AccountNameRenderer from '../../../../components/table-cells/AccountNameRenderer';
import OpportunityNameRenderer from '../../../../components/table-cells/OpportunityNameRenderer';
import ArrayRenderer from '../../../../components/table-cells/ArrayRenderer';
import PathDisplay from '../../../../components/search-path/path';

class ResultModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.close = this.close.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.getCellStyle = this.getCellStyle.bind(this);
  }

  close() {
    this.setState({ show: false }, () => {
      this.props.onHide();
    });
  }


  getFieldType() {
    const { field } = this.props;
    return field?.type;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  componentWillReceiveProps(nextProps) {
    if (
        (!this.props.collector && nextProps.collector) ||
        (this.props.collector && nextProps.collector && this.props.collector.id !== nextProps.collector.id)
      ) {
      this.setState({ show: true });
    }
  }

  getCellStyle(params) {
    const isFirst = params?.column.left === 0; // TODO: check this
    if (isFirst) {
      return {
        paddingLeft: '50px',
      };
    }
    return {};
  }


  getNameColumn(column) {
    const { collector } = this.props;
    const isAccount = collector.collector_type === 'experience';
    const fieldType = this.getFieldType();

    return {
      colId: column._id,
      headerName: isAccount ? 'Account' : 'Opportunity',
      width: column.width,
      hide: !column.is_visible,
      field: 'name',
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      cellRenderer: isAccount ? AccountNameRenderer: OpportunityNameRenderer,
      ...(fieldType === 'Contact' ? {
        rowGroup: true,
        hide: true,
      } : {}),
      cellRendererParams: {
        enableAutoHeight: true,
        column,
      },
    };
  }


  getTagColumn(column) {
    const fieldType = this.getFieldType();
    let field = '';
    if (fieldType === 'Opportunity') {
      field = 'tags';
    } else if (fieldType === 'Account') {
      field = 'account.tags';
    } else if (fieldType === 'Contact') {
      field = 'tags'; // array was flatten
    } 
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field,
      cellRenderer: ArrayRenderer,
      cellRendererParams: {
        enableAutoHeight: true,
        column,
      },
    };
  }

  getContactColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'contact_name',
      cellStyle: this.getCellStyle,
      cellRendererParams: {
        enableAutoHeight: true,
        column,
      },
    };
  }

  getContactEmailColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'email',
      cellRendererParams: {
        enableAutoHeight: true,
        column,
      },
    };
  }
  

  getColumnDefs() {
    const { tableColumns, collector } = this.props;
    const isAccount = collector.collector_type === 'experience';

    return reduce(tableColumns, (columns, tableColumn) => {
      let column = null;
      if (tableColumn.tag === 'name') {
        column = this.getNameColumn(tableColumn);
      } else if (tableColumn.tag === 'tags') {
        column = this.getTagColumn(tableColumn);
      } else if (tableColumn.tag === 'contact') {
        column = this.getContactColumn(tableColumn);
      } else if (tableColumn.tag === 'email') {
        column = this.getContactEmailColumn(tableColumn);
      } else {
        column = {
          column: tableColumn,
          customFieldType: isAccount ? CUSTOM_FIELD_TYPES.ACCOUNT :  CUSTOM_FIELD_TYPES.OPPORTUNITY,
        };
      }
      if (column) {
        columns.push(column);
      }
      return columns;
    }, []);
  }

  renderTable() {
    const { collector, tableName } = this.props;
    if (!collector) {
      return null;
    }
    const isAccount = collector.collector_type === 'experience';
    const columnDefs = this.getColumnDefs();

    return (
      <GodTable
        id={tableName}
        columnDefs={columnDefs}
        rowData={collector.items}
        reactNext
        onGridReady={this.onGridReady}
        animateRows

        groupUseEntireRow
        groupDisplayType="groupRows"
        groupDefaultExpanded={1}
        getRowNodeId={d => d.id}
        enableFullScreen={false}
        hideStatusBar
        tableManageConfigs={{
          enableCustomMeta: false,
          validCustomMetaObjects: isAccount ? ['Account'] : ['Opportunity'],
        }}
        height={400}
        resourceType={isAccount ? GodTable.RESOURCE_TYPE.ACCOUNT: GodTable.RESOURCE_TYPE.OPPORTUNITY}
      />
    )
  }

  render() {
    const { field, collector } = this.props;
    return (
      <Modal bsSize="lg" show={this.state.show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>Submission Results</h4>
        </Modal.Header>
        <Modal.Body>
          {field && collector && <p>Applied the <PathDisplay startingNode={field.type} paths={field.field} /> values as TruVoice tags to all {lowerCase(pluralize(field.type, 2))} that have been previously submitted to the Truvoice collector <strong>{collector.collector_name}</strong>:</p>}
          {this.renderTable()}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close} bsStyle="default">Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


function mapStateToProps(state, ownProps) {
  const { field } = ownProps;
  const fieldType = field?.type;
  let tableName = 'tag-result-table';
  if (fieldType === 'Opportunity') {
    tableName = 'tag-result-opportunity-table';
  } else if (fieldType === 'Account') {
    tableName = 'tag-result-account-table';
  } else if (fieldType === 'Contact') {
    tableName = 'tag-result-contact-table';
  }
  return {
    tableColumns: getTablePreference(state, tableName),
    tableName,
  };
}

ResultModal.propTypes = {
  collector: PropTypes.shape({
  }),
  onHide: PropTypes.func,
  field: PropTypes.shape({
    _id: PropTypes.string,
    type: PropTypes.string,
    field: PropTypes.arrayOf(PropTypes.string),
  }),
  tableName: PropTypes.string,
  tableColumns: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    description: PropTypes.string,
    is_system: PropTypes.bool,
    is_visible: PropTypes.bool,
    position: PropTypes.number,
    width: PropTypes.number,
    tag: PropTypes.string,
    label: PropTypes.string,
    target_object: PropTypes.string,
    target_field: PropTypes.string,
  })),
};

ResultModal.defaultProps = {
  collector: null,
  onHide: () => {},
  tableColumns: [],
  tableName: null,
};

export default connect(mapStateToProps)(ResultModal);
